module.exports = __webpack_public_path__ + "static/media/titlecard_favepay@2x.ac616003.jpg";